import React from 'react';

import { LegacyIconProps } from './iconUtilities';

export function ZoomOutIcon({ 
    width = 16, 
    height = 16, 
    color = '#666666'
}: LegacyIconProps) {
    return (
        <svg id='mapZoomOutIcon' className='mapIcon' viewBox='0 0 16 3' width={width} height={height} fill={color}>
            <rect x='0' y='0' width='16' height='3' rx='1'></rect>
        </svg>
    );
}
